// Shared by the Library and Archive "Research Categories" forms.
//
// The four research_categoryN_alias dropdowns are the source of truth. research_categoryN (the
// category's `value`, e.g. "1_CinemaEducation") is looked up from the research categories API
// (getResearchCategoriesAPI), whose entries carry both `alias` and `value`.

export const RESEARCH_CATEGORY_SLOTS = [1, 2, 3, 4];

const aliasField = (i) => `research_category${i}_alias`;
const valueField = (i) => `research_category${i}`;

// getResearchCategoriesAPI() returns rows of [{ key, value }, ...]; build alias -> value
export const toResearchCategoryValueMap = (researchCategories = []) => {
  const valueByAlias = {};
  researchCategories.forEach((itemArray) => {
    const entity = (itemArray || []).reduce((acc, { key, value }) => {
      acc[key] = value;
      return acc;
    }, {});
    if (entity.alias) {
      valueByAlias[entity.alias] = entity.value;
    }
  });
  return valueByAlias;
};

// Slots whose alias differs from the record as loaded
export const getChangedResearchCategorySlots = (formData = {}, original = {}) =>
  RESEARCH_CATEGORY_SLOTS.filter(
    (i) => (formData[aliasField(i)] || "") !== (original[aliasField(i)] || ""),
  );

// For every changed slot, set research_categoryN from its alias (or clear both when the alias is
// cleared), then rebuild research_categories (and aliasArrayField, when given) from the slots in
// slot order, blanks removed, no duplicates. extraValueFields are appended to research_categories
// as-is (e.g. Archive's additional_research_categories, which the backend also includes).
// Unchanged records are returned as-is. Returns { data } or { missingAlias } when a selected alias
// is not in the research categories list.
export const syncResearchCategorySlots = (
  formData,
  original,
  valueByAlias,
  { aliasArrayField = null, extraValueFields = [] } = {},
) => {
  const changedSlots = getChangedResearchCategorySlots(formData, original);
  if (changedSlots.length === 0) {
    return { data: formData };
  }

  const next = { ...formData };
  for (const i of changedSlots) {
    const selectedAlias = (next[aliasField(i)] || "").trim();
    if (!selectedAlias) {
      next[aliasField(i)] = "";
      next[valueField(i)] = "";
      continue;
    }
    const categoryValue = valueByAlias[selectedAlias];
    if (!categoryValue) {
      return { missingAlias: selectedAlias };
    }
    next[aliasField(i)] = selectedAlias;
    next[valueField(i)] = categoryValue;
  }

  const unique = (values) => [...new Set(values.filter(Boolean))];
  next.research_categories = unique([
    ...RESEARCH_CATEGORY_SLOTS.map((i) => next[valueField(i)]),
    ...extraValueFields.map((field) => next[field]),
  ]);
  if (aliasArrayField) {
    next[aliasArrayField] = unique(
      RESEARCH_CATEGORY_SLOTS.map((i) => next[aliasField(i)]),
    );
  }
  return { data: next };
};
